export default {
      id: "icon-youtube-usage",
      viewBox: "0 0 24 16.804",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-youtube",
      toString: function () {
        return this.url;
      }
    }